export default __webpack_public_path__ + "6198c1ce9003c1f24816ca4ffe53d011.jpg";